<div class="canvas-head">
  <div class="entity-breadcrumbs">
    <span class="entity-breadcrumb-label">Route</span>
    <span class="entity-breadcrumb-value">{{ selectedRouteDisplayTitle || 'No route selected' }}</span>
    @if (selectedRoute) {
    <button class="icon-button entity-properties-trigger properties-popover-trigger" type="button"
      (click)="routePropertiesOpen.emit($event)" popovertarget="properties-popover"
      title="Edit route properties">
      <i class="fa fa-pencil-square-o"></i>
    </button>
    }
    <span class="entity-breadcrumb-separator">></span>
    <span class="entity-breadcrumb-label">Component</span>
    <span class="entity-breadcrumb-value">{{ selectedComponentDisplayTitle || 'No component selected' }}</span>
    @if (selectedComponent) {
    <button class="icon-button entity-properties-trigger properties-popover-trigger" type="button"
      (click)="componentPropertiesOpen.emit($event)" popovertarget="properties-popover"
      title="Edit component properties">
      <i class="fa fa-pencil-square-o"></i>
    </button>
    }
  </div>
</div>

<div class="canvas-body">
  @if (selectedComponent) {
  <app-tree [items]="editorChildItems" [level]="editorLevel" [treeType]="'source'"
    [parentItem]="selectedComponent" [isEditingEnabled]="isEditingEnabled"
    [searchTerm]="searchTerm" [isDualPane]="isDualPane"
    [pageHeights]="pageHeightMap"
    (orderChanged)="orderChanged.emit()"
    (nameChanged)="onTreeNameChanged()"></app-tree>
  }
  @if (!selectedComponent) {
  <div class="empty-state">Select a component from the sidebar to edit its elements.</div>
  }
</div>
